import apiClient from '../index';

export interface UserInitResponse {
  account_type: any;
  tokens_left_current_period: any;
  token_allowance: any;
}

export interface UserInitRequest {
  user_id: string;
}

export interface UserResponse {
  tokens_left: undefined;
  user_id: string;
  account_type: string;
  token_allowance: number;
  tokens_left_current_period: number;
  created_at: Date;
}

export const userApi = {
  // User operations
  initUser: (data: UserInitRequest) =>
    apiClient.post<UserInitResponse>('/api/users/init-profile', data),
  getUser: () =>
    apiClient.get<UserResponse>('/api/users/me'),
};